import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input-gg';
import { ColorPickerModule } from 'ngx-color-picker';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CultureLocaleService } from 'projects/Widget/src/app/services/culture-locale.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { LanguageDataService } from '../../src/app/data-services/language-data.service';
import { TextFilterPipe } from '../app/pipe/text-filter.pipe';
import { AutofacetsCoreModule } from './../../../Autofacets-Core/src/app/app.module';
import { CustomLoader } from '../app/services/custom-loader.service';
import { AppIntializer } from './app-intializer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CurrencySpacePipe } from './pipe/currency-space.pipe';
import { BookingSectionComponent } from './views/booking-section/booking-section.component';
import { AdditionalServicesComponent } from './views/booking-steps/additional-services/additional-services.component';
import { BookingStepsComponent } from './views/booking-steps/booking-steps.component';
import { ContactComponent } from './views/booking-steps/contact/contact.component';
import { TermNConditionComponent } from './views/booking-steps/contact/term-n-condition/term-n-condition.component';
import { AddVehicleCustomerComponent } from './views/booking-steps/find-car/add-vehicle-cutomer/add-vehicle-customer.component';
import { ConfirmRegMobileNoComponent } from './views/booking-steps/find-car/confirm-reg-mobile-no/confirm-reg-mobile-no.component';
import { FindCarComponent } from './views/booking-steps/find-car/find-car.component';
import { SelectServicesComponent } from './views/booking-steps/select-services/select-services.component';
import { MapComponent } from './views/booking-steps/select-workshop/map/map.component';
import { SelectDealerComponent } from './views/booking-steps/select-workshop/select-dealer/select-dealer.component';
import { SelectWorkshopComponent } from './views/booking-steps/select-workshop/select-workshop.component';
import { CookiePolicyComponent } from './views/cookie-policy/cookie-policy.component';
import { DisclaimerInfoComponent } from './views/disclaimer-info/disclaimer-info.component';
import { HeaderComponent } from './views/header/header.component';
import { SummaryComponent } from './views/summary/summary.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { AddContactComponent } from './views/booking-steps/find-car/add-contact/add-contact.component';
import { JwtAppInterceptor } from 'projects/Autofacets-Core/src/app/interceptor/jwt-app.interceptor';
import { SafePipe } from '../../../Administration/src/app/pipe/img-safe.pipe';
import { AfDirectiveModule } from 'projects/Autofacets-Core/src/app/directives/af-directive-core.module';
import { GoogleMapsModule } from '@angular/google-maps';

export function createTranslateLoader(commonLocalizationService: LanguageDataService) {
  return new CustomLoader(commonLocalizationService);
}

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    BookingStepsComponent,
    BookingSectionComponent,
    FindCarComponent,
    SelectServicesComponent,
    SelectWorkshopComponent,
    ContactComponent,
    SummaryComponent,
    AppComponent,
    SelectDealerComponent,
    AddVehicleCustomerComponent,
    TextFilterPipe,
    MapComponent,
    CurrencySpacePipe,
    AdditionalServicesComponent,
    ConfirmRegMobileNoComponent,
    DisclaimerInfoComponent,
    CookiePolicyComponent,
    TermNConditionComponent,
    AutoFocusDirective,
    AddContactComponent,
    SafePipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    AutofacetsCoreModule.forRoot(),
    FormsModule,
    FilterPipeModule,
    GoogleMapsModule,
    ReactiveFormsModule,
    NgbModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    ColorPickerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [LanguageDataService]
      }
    }),
    AfDirectiveModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtAppInterceptor, multi: true },
    CurrentLanguage,
    DatePipe,
    CultureLocaleService,
    {
      provide: APP_INITIALIZER,
      useFactory: AppIntializer,
      deps: [CultureLocaleService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      deps: [CultureLocaleService],
      useFactory: (CultureLocaleService) => CultureLocaleService.getLocale()
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
